import type { IItem } from '../types';

export function itemInformationTransform(item: IItem) {
  return {
    category: item.category,
    title: item.title,
    id: item.pimId,
    cardData: item.items.filter((item: IItem) => !!item.href),
    text: item.text,
    taggingProduct: item.dfTaggingProduct,
    children: item.dfChildren,
    categoryId: item.dfCategory,
    childOrder: item.dfChildren,
  };
}
